import { render, staticRenderFns } from "./userhome35.vue?vue&type=template&id=2dafbf08&scoped=true&"
import script from "./userhome35.vue?vue&type=script&lang=ts&"
export * from "./userhome35.vue?vue&type=script&lang=ts&"
import style0 from "./userhome35.vue?vue&type=style&index=0&id=2dafbf08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dafbf08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dafbf08')) {
      api.createRecord('2dafbf08', component.options)
    } else {
      api.reload('2dafbf08', component.options)
    }
    module.hot.accept("./userhome35.vue?vue&type=template&id=2dafbf08&scoped=true&", function () {
      api.rerender('2dafbf08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/home/modules/home/userhome35.vue"
export default component.exports